import React, { useContext, useEffect, useState } from "react";
import Modal from "./Modal";
import icon_dropdown from "../assets/icons/tabler_chevron-down.svg";
import icon_close from "../assets/icons//modal-add-close-button.svg";
import { TodosContext } from "../pages/ItemDetail";
function FormTodo(props) {
  const {
    isModal,
    updateTodoItem,
    resetItemUpdate,
    handleModalToggle,
    InputTodo,
    priorities,
    updateTodo,
  } = useContext(TodosContext);
  const [title, setTitle] = useState("");
  const [todoId, setTodoId] = useState(null);
  const [priority, setPriority] = useState(priorities[0]);
  const [isOpen, setIsOpen] = useState(false);
  const resetForm = () => {
    setTitle("");
    setPriority(priorities[0]);
    resetItemUpdate();
  };
  const handleOptionClick = (option) => {
    setPriority(option);
    setIsOpen(false);
  };
  const closeModal = () => {
    handleModalToggle();
    resetForm();
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      title: title,
      priority: priority.value,
      is_active: 1,
    };
    todoId !== null ? updateTodo(todoId, data) : InputTodo(data);
    handleModalToggle();
    resetForm();
  };

  useEffect(() => {
    if (updateTodoItem !== null) {
      const fetchPriority = priorities.filter((res) => {
        return res.value === updateTodoItem.priority;
      });
      setPriority(...fetchPriority);
      setTitle(updateTodoItem.title);
      setTodoId(updateTodoItem.id);
    }
  }, [updateTodoItem]);

  return (
    <Modal data="modal-add" back={handleModalToggle} isModal={isModal}>
      <div className="flex flex-row justify-between items-center p-[38px] h-[70px] border-b border-[#E5E5E5] ">
        <h1
          data-cy="modal-add-title"
          className="text-sans text-[18px] font-bold"
        >
          Tambah List Item
        </h1>
        <img
          data-cy="modal-add-close-button"
          onClick={() => closeModal()}
          className="cursor-pointer"
          alt="close modal"
          src={icon_close}
        />
      </div>
      <form onSubmit={handleSubmit} className="w-[830px] text-sans ">
        <div className="p-[38px] border-b border-[#E5E5E5]">
          <div className="mb-4">
            <label
              data-cy="modal-add-name-title"
              htmlFor="title"
              className="block text-gray-700 font-bold mb-2"
            >
              Nama List Item
            </label>
            <div>
              <input
                required
                data-cy="modal-add-name-input"
                type="text"
                id="title"
                name="title"
                placeholder="Tambahkan nama list item"
                className="shadow appearance-none border rounded w-full h-[52px] py-2 px-3 text-gray-700 leading-tight focus:outline-primary focus:shadow-outline"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>
          <div className="mb-4">
            <label
              data-cy="modal-add-priority-title"
              htmlFor="priority"
              className="block text-gray-700 font-bold mb-2"
            >
              Priority
            </label>
            <div className="relative">
              <div
                className="shadow appearance-none border rounded w-[205px] h-[52px] focus:outline-primary focus:shadow-outline py-2 px-3 text-gray-700 leading-tight focus:shadow-outline flex items-center justify-between cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
              >
                {priority && (
                  <div
                    data-cy="modal-add-priority-dropdown"
                    className="flex items-center justify-start gap-[19px] w-full"
                  >
                    <div
                      className={`w-[14px] h-[14px] rounded-full bg-[${priority.color}]`}
                    ></div>
                    {priority.label}
                    <img
                      className="ml-auto"
                      src={icon_dropdown}
                      alt="dropdown"
                    />
                  </div>
                )}
              </div>
              {isOpen && (
                <div className="absolute z-10 bg-white border rounded-md py-2 px-4 mt-1 w-[205px]">
                  {priorities.map((option) => (
                    <div
                      data-cy="modal-add-priority-item"
                      key={option.value}
                      className="flex flex-row items-center gap-[19px] cursor-pointer hover:bg-gray-200 py-1 px-2 rounded-md"
                      onClick={() => handleOptionClick(option)}
                    >
                      <div
                        className={`w-[14px] h-[14px] rounded-full bg-[${option.color}]`}
                      ></div>

                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end py-[15px]">
          <button
            data-cy="modal-add-save-button"
            type="submit"
            className="bg-primary text-sans w-[150px] h-[54px] hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline"
            disabled={title.length === 0}
          >
            Simpan
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default FormTodo;
